<script>
import { productivityFromDeviceEvents } from '@utils/data/device-event'

export default {
  components: {},

  props: {
    deviceEventsForShift: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    productivity: function() {
      return productivityFromDeviceEvents(this.$moment, this.deviceEventsForShift)
    },

    radialBarSeriedData: function() {
      let totalTime =
        this.productivity.runningEventSeconds +
        this.productivity.holdEventSeconds +
        this.productivity.idleEventSeconds
      let runningEventPercentage =
        (this.productivity.runningEventSeconds / totalTime) * 100
      let holdEventPercentage = (this.productivity.holdEventSeconds / totalTime) * 100
      let idleEventPercentage = (this.productivity.idleEventSeconds / totalTime) * 100
      console.log([
        Math.round(runningEventPercentage),
        Math.round(holdEventPercentage),
        Math.round(idleEventPercentage),
      ])
      return [
        Math.round(runningEventPercentage),
        Math.round(holdEventPercentage),
        Math.round(idleEventPercentage),
      ]
    },
  },

  methods: {
    setNavigateDetails: function(deviceName, deviceId) {
      this.$router.push({
        name: 'Device State History Detail',
        params: { deviceName: deviceName, deviceId: deviceId },
      })
    },
  },
}
</script>

<template>
  <div>
    <p v-for="data in radialBarSeriedData" :key="data">{{ data }}</p>
  </div>
</template>
